// extracted by mini-css-extract-plugin
export default {"list":"PrescriptionList_list__HYy46","row":"PrescriptionList_row__7XtUT"};